import {db} from './firebase.js';

export const userLifeChecklist = (cb) => {
    /*db.collection("life-checklists").doc(user.uid).get().then(function(data){
      if(!data.exists){
        cb(false, null, user);
      }else{
        cb(true, data.data(), user);
      }
  });*/
}

export const getLifeChecklist = (uid, cb) => {
  var userPromise = db.collection("users").doc(uid).get().then(function(user){
    var userData = user.data();
    if(userData){
      return {name: userData.name, profilePic: userData.profilePic, username: userData.username, uid: userData.uid};
    }else{
      return null;
    }
  });

  var checklistPromise = db.collection("life-checklists").doc(uid).get().then(function(checklist){
    return checklist.data();
  });

  Promise.all([checklistPromise, userPromise]).then(function(results) {
    return cb({checklist: results[0], user: results[1]});
  });
}

export const getLifeChecklistByUsername = (username, cb) => {
  console.log("in fuction" + Date.now());
  var userPromise = db.collection("users").where("username", "==", username).get().then(function(user){
    console.log("got user " + Date.now());
    return user.docs[0].data();
  });

  var checklistPromise = db.collection("life-checklists").where("username", "==", username).get().then(function(checklist){
    console.log("got checklist " + Date.now());
    return checklist.docs[0].data();
  });

  Promise.all([checklistPromise, userPromise]).then(function(results) {
    console.log("Returning data " + Date.now());
    return cb({checklist: results[0], user: results[1]});
  });
}

function isValidateChecklist(arr){
  if(arr.length !== 66){
    return false;
  }
  for(var x = 0; x < arr.length; x++){
    if(arr[x] !== true && arr[x] !== false && arr[x] !== 0 && arr[x] !== 1){
      console.log("not true:");
      console.log(arr[x]);
      return false;
    }
  }
  return true;
}

function booleanToInt(arr){
  var newArr = [];
  for(var x = 0; x < arr.length; x++){
    if(arr[x]){
      newArr.push(1);
    }else{
      newArr.push(0);
    }
  }
  return newArr;
}

export const createLifeChecklist = (data, cb) => {
  userLifeChecklist(function(hasChecklist, checklist, user){
    if(!hasChecklist && isValidateChecklist(data)){
      /*auth.getUserByUid(user.uid, function(fullUser){
        var booleanData = booleanToInt(data);
        db.collection("life-checklists").doc(user.uid).set({
          checklist: booleanData,
          uid: user.uid,
          username: fullUser.username
        }).then(function(){
          console.log("new hcecklis");
          console.log(checklist);
          cb({checklist: {checklist: booleanData, uid: user.uid}, user: fullUser});
        });
      });*/
    }
  });
}

export const updateLifeChecklist = (data) => {
  userLifeChecklist(function(hasChecklist, checklist, user){
    if(isValidateChecklist(data)){
      db.collection("life-checklists").doc(user.uid).update({
        checklist: booleanToInt(data)
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/firebase/life-checklist.js